import intl from "react-intl-universal";
import {
  Search,
  Send,
  ListChecks,
  SquareUserRound,
  UsersRound,
  Activity,
  MessageSquare,
  ChartColumn,
  Upload,
  FileText,
  Sparkles,
  CreditCard,
  Receipt,
  Mail,
  PlayCircle,
  FolderOpen,
  Flame,
  UserCog,
  Store,
  LayoutDashboard,
  Users,
  Film,
  Briefcase,
  ClipboardCheck,
  Repeat,
} from "lucide-react";

const menu = {
  auth_connection_manage: {
    title: "auth_connection_manage",
    iconComponent: Search,
  },
  auth_cooperation: {
    title: "auth_cooperation",
    iconComponent: Users,
  },
  auth_content: {
    title: "auth_content",
    iconComponent: Film,
  },
  auth_ai_assistant: {
    title: "auth_ai_assistant",
    iconComponent: Repeat,
  },
  auth_work_space: {
    title: "auth_work_space",
    iconComponent: Briefcase,
  },
  auth_order_menutitle: {
    title: "auth_order_menutitle",
  },
  auth_home_page: {
    title: "auth_home_page",
  },
  anth_warning: {
    title: "anth_warning",
  },
  "/find": {
    title: "auth_search_title",
    iconComponent: Search,
  },
  "/raidsys": {
    title: "auth_connection_task",
    iconComponent: Send,
  },
  "/list": {
    title: "auth_list_title",
    iconComponent: ListChecks,
  },
  "/incoming": {
    title: "auth_my_talents",
    iconComponent: SquareUserRound,
  },
  "/group": {
    title: "auth_group_manage",
    iconComponent: UsersRound,
  },
  "/warning": {
    title: "anth_warning",
    iconComponent: ClipboardCheck,
  },
  "/creatorStatus": {
    title: "auth_creator_status",
    iconComponent: Activity,
  },
  "/creatorMessages": {
    title: "auth_creator_messages",
    iconComponent: MessageSquare,
  },
  "/videoAnalytics": {
    title: "auth_video_analytics",
    iconComponent: ChartColumn,
  },
  "/viral": {
    title: "auth_viral",
    iconComponent: Flame,
  },
  "/script": {
    title: "auth_script",
    iconComponent: FileText,
  },
  "/video": {
    title: "auth_video",
    iconComponent: PlayCircle,
  },
  "/asset": {
    title: "auth_asset",
    iconComponent: FolderOpen,
  },
  "/tikTokPublish": {
    title: "auth_tiktok_publish",
    iconComponent: Upload,
  },
  "/scriptLibrary": {
    title: "auth_script_library",
    iconComponent: FileText,
  },
  "/sendEmail": {
    title: "auth_send_email",
    iconComponent: Mail,
  },
  "/score": {
    title: "auth_talent_score_config",
    iconComponent: Sparkles,
  },
  "/sub-accounts": {
    title: "auth_sub_accounts",
    iconComponent: UserCog,
  },
  "/shopList": {
    title: "auth_shop_list",
    iconComponent: Store,
  },
  "/package": {
    title: "auth_package_title",
    iconComponent: CreditCard,
  },
  "/order-list": {
    title: "auth_order_title",
    iconComponent: Receipt,
  },
  "/content-creation": {
    title: "auth_content_creation",
    iconComponent: LayoutDashboard,
  },
};

const menuMapData = (key) => {
  if (!key) {
    return {};
  }
  return menu[key] || {};
};

export { menuMapData, menu };
